import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CheckoutSummary = () => {
  const navigate = useNavigate();
  const [showTaxDetails, setShowTaxDetails] = useState(false);
  const [selectedItemTaxes, setSelectedItemTaxes] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null); // Store the selected item
  const checkOutDetails = useSelector((state) => state.user.checkoutDetails);
  const selectedAddress = useSelector((state) => state.user.selectedAddress);

  const handleProceedToPayment = () => {
    navigate("/checkoutform"); // Navigate to the CheckoutForm route
  };

  const handleShowTaxes = (item, taxes) => {
    setSelectedItem(item); // Set the selected item
    setSelectedItemTaxes(taxes);
    setShowTaxDetails(true);
  };

  const handleCloseModal = () => {
    setShowTaxDetails(false);
    setSelectedItemTaxes([]);
    setSelectedItem(null); // Clear selected item
  };

  return (
    <div className="bg-gray-900 p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-semibold text-gray-300 mb-6">Order Summary</h2>
      <div className="space-y-4">
        {checkOutDetails?.checkoutItems?.map((item, index) => {
          return (
            <div key={index} className="flex justify-between items-center">
              <div>
                <p className="text-gray-100 font-bold italic">
                  {item?.productName} <span className="text-sm font-normal">(including taxes)</span>
                </p>
                <button
                  onClick={() => handleShowTaxes(item, item?.taxes)} // Pass the item here
                  className="text-indigo-500 text-sm underline"
                >
                  View Taxes
                </button>
              </div>
              <p className="text-gray-100">${(item?.itemFinalPrice)}.00</p>
            </div>
          );
        })}

        <hr className="border-gray-100 my-4" />
        <div className="flex justify-between items-center">
          <p className="text-lg italic text-gray-100">Total Tax Amount <span className="text-sm">(including GST)</span></p>
          <p className="text-lg font-bold text-gray-100">${(checkOutDetails?.totalTaxAmount)}.00</p>
        </div>
        <div className="flex justify-between items-center">
          <p className="text-lg font-bold text-gray-100">Total</p>
          <p className="text-lg font-bold text-gray-100">${(checkOutDetails?.totalFinalPrice)}.00</p>
        </div>
      </div>
      <button
        onClick={handleProceedToPayment}
        disabled={!selectedAddress} // Disable button if selectedAddress is null
        className={`mt-6 w-full py-3 rounded-lg font-semibold transition duration-300 ${
          !selectedAddress
            ? "bg-gray-500 cursor-not-allowed text-gray-300" // Disabled styles
            : "bg-indigo-600 text-white hover:bg-primary-dark" // Enabled styles
        }`}
      >
        Proceed to Payment
      </button>

      {/* Tax Details Modal */}
      {showTaxDetails && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center  items-center z-50">
          <div className="bg-white rounded-lg p-6 shadow-lg w-[90%] overflow-x-scroll md:w-[50%]">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Tax Details</h3>
            {/* Table to display tax details */}
            <table className="md:w-full table-auto">
              <thead className="">
                <tr className="bg-gray-200 ">
                  <th className="py-2 px-4 text-left text-gray-600">Price Without Tax</th>
                  <th className="py-2 px-4 text-left text-gray-600">Tax Name</th>
                  <th className="py-2 px-4 text-left text-gray-600">Tax Percentage</th>
                  <th className="py-2 px-4 text-left text-gray-600">Tax Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectedItemTaxes.map((tax, idx) => {
                  // Calculate tax for productPriceWithoutTax
                  const taxAmountWithoutTax = selectedItem?.productPriceWithoutTax
                    ? (selectedItem?.productPriceWithoutTax * tax.taxPercentage) / 100
                    : 0;

                  return (
                    <tr key={idx} className="border-t border-gray-200 ">
                      <td className="py-2 px-4 text-gray-600">${Math.floor(selectedItem?.finalPrice)?.toFixed(2)}</td>
                      <td className="py-2 px-4 text-gray-600">{tax.taxName}</td>
                      <td className="py-2 px-4 text-gray-600">{tax.taxPercentage}%</td>
                      <td className="py-2 px-4 text-gray-600">${tax.taxAmount.toFixed(2)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <button
              onClick={handleCloseModal}
              className="mt-6 w-full py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutSummary;